import AbstractTokenHandler from "./AbstractTokenHandler";
import AbstractContext from "../../AbstractContext";
import AbstractSession from "../AbstractSession";

/**
 * A DefaultTokenHandler is the default implementation of a {@link TokenHandler} for the {@link AbstractSession}.
 * It is just using all default methods defined in the {@link AbstractTokenHandler}.
 */
export default class DefaultTokenHandler<C extends AbstractContext<C, S>, S extends AbstractSession<C, S>>
	extends AbstractTokenHandler<C, S> {
}